// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__2gGnN","tooltiptext":"Tooltip_tooltiptext__2uYv5"};